import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./RichTextInput.css";

const RichTextInput = ({
  value,
  onChange,
  placeholder,
  readOnly = false,
  width = "100%",
  error,
  maxLength,
  showCharCount,
  className = "",
}) => {
  const getPlainTextLength = (html) => {
    if (!html) return 0;
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent.length;
  };

  const handleChange = (content) => {
    if (maxLength && getPlainTextLength(content) > maxLength) return;
    onChange(content);
  };

  return (
    <div
      className={`rich-text-input${error ? " has-error" : ""}${className ? ` ${className}` : ""}`}
      style={{ width }}
    >
      <ReactQuill
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        readOnly={readOnly}
        modules={{
          toolbar: readOnly
            ? false
            : [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
                ["clean"],
              ],
        }}
      />

      {showCharCount && maxLength && (
        <div className="char-count">
          {getPlainTextLength(value)} / {maxLength}
        </div>
      )}
    </div>
  );
};

export default RichTextInput;
